export function openDB() {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open("audioDB", 1);

        req.onupgradeneeded = (e) => {
            const db = e.target.result;
            db.createObjectStore("files", { keyPath: "id" });
        };

        req.onsuccess = () => resolve(req.result);
        req.onerror = reject;
    });
}

export async function saveFile(file) {
    const db = await openDB();

    const tx = db.transaction("files", "readwrite");
    const store = tx.objectStore("files");
    const id = `${file.name}_${file.lastModified}`;
    store.put({
        id: id,
        file: file,
        name: file.name,
        type: file.type
    });

    return tx.complete;
}

export async function loadFile() {
    const db = await openDB();

    return new Promise((resolve) => {
        const tx = db.transaction("files", "readonly");
        const store = tx.objectStore("files");

        const req = store.getAll(); 
        req.onsuccess = () => resolve(req.result?.file);
    });
}


export async function clearAllFiles() {
    const db = await openDB();

    const tx = db.transaction("files", "readwrite");
    const store = tx.objectStore("files");

    // 全レコードをクリア
    store.clear();

    return tx.complete;
}